export default __webpack_public_path__ + "static/media/navbar-shorten-link-orange.d3b04daf.svg";